<template>
	<div>
		<el-row v-if="value">
			<el-row class="crumbs-box">
				<el-row>
					<el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
						<el-breadcrumb-item>当前位置</el-breadcrumb-item>
						<el-breadcrumb-item>用户管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-row>
				<el-row class="selectbox">
					<el-col :span="2" class="seachTitleContent">
						用户名:
					</el-col>
					<el-col :span="3">
						<input type="text" class="select" v-model="user">
					</el-col>
					<el-col :span="1" :offset="1">
						<button @click="searchName" class="searchbtn">查询</button>
					</el-col>
					<el-col :span="1" style="margin-left: 20px;">
						<button @click="reset" class="resetbtn">重置</button>
					</el-col>
				</el-row>
			</el-row>
			<el-row class="formbox">
				<el-row class="addbox">
					<el-col :span="3">
						<button @click="add" class="searchbtn">新增</button>
					</el-col>
				</el-row>
				<el-row>
					<table class="tablebox">
						<tr class="table-firsttitle">
							<td>用户名</td>
							<td>创建时间</td>
							<td>创建人</td>
							<td>操作</td>
						</tr>
						<tr class="table-trtitle" v-for="item in form">
							<td>
								<p class="tableTitle" :title="item.name">
									{{item.name}}
								</p>
							</td>
							<td>{{item.createTime}}</td>
							<td>
								<p class="tableTitle" :title="item.createName">
									{{item.createName}}
								</p>
							</td>
							<td class="head">
								<span @click="edit(item)">编辑</span>
								<span @click="del(item)">删除</span>
							</td>
						</tr>
					</table>
				</el-row>
			</el-row>
			<div class="block" style="margin-top: 20px;">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="currentPage"
					:page-sizes="[10,20,30]"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</el-row>
		
		<el-row v-else id="add">
			<el-row class="add-title">
				新增用户
			</el-row>
			<el-row class="add-input">
				<el-col :span="3" class="title">
					用户名:
				</el-col>
				<el-col :span="10" :offset="1" v-if="isedit==false">
					<input v-model="saveForm.name" class="select" maxlength="100">
				</el-col>
				<el-col :span="10" :offset="1" v-else>
					<input v-model="saveForm.name" class="select" maxlength="100" disabled>
				</el-col>
			</el-row>
			<el-row class="add-input">
				<el-col :span="3" class="title">
					密码:
				</el-col>
				<el-col :span="10" :offset="1">
					<input v-model="saveForm.password" class="select" maxlength="100">
					<el-row class="total">
						*密码位数不少于六位
					</el-row>
				</el-col>
			</el-row>
			<el-row class="add-input">
				<el-col :span="3" class="title">
					确认密码:
				</el-col>
				<el-col :span="10" :offset="1">
					<input v-model="saveForm.passwordAgain" class="select" maxlength="100">
				</el-col>
			</el-row>
			
			<el-row class="add-input">
				<el-col :span="1" :offset="4">
					<button @click="save" class="savebtn">保存</button>
				</el-col>
				<el-col :span="1" style="margin-left: 20px">
					<button @click="cancel" class="savebtn">取消</button>
				</el-col>
			</el-row>
		</el-row>
	</div>
</template>

<script>
	import { searchUserPage , deleteUser , chackName , editUser } from '@/api/index.js'
	export default
	{
		data()
		{
			return{
				form:[],
				// 总共页数
				page:1,
				// 每页条数
				pageSize:10,
				// 当前页数
				currentPage:1,
				// 总条数
				total:0,
				
				user:'',
				
				// 显示页面
				value:true,
				
				saveForm:{},
				
				id:'',
				
				isedit:false,
			}
		},
		created()
		{
			this.getUser()
		},
		methods:
		{
			getUser()
			{
				searchUserPage({page:this.page,pageSize:this.pageSize})
				.then((response)=>
				{
					this.form=response.data.data.records;
					console.log(this.form,'所有的值')
					this.currentPage=response.data.data.current;
					this.page=response.data.data.pages;
					this.pageSize=response.data.data.size;
					this.total=response.data.data.total;
				})
			},
			// 当前条数
			handleSizeChange(val) 
			{
				this.page=1;
				this.pageSize=val;
				this.getUser()
			},
			// 当前页数
			handleCurrentChange(val) 
			{
				this.page=val;
				searchUserPage({page:this.page,pageSize:this.pageSize})
				.then((response)=>
				{
					this.form=response.data.data.records;
				})
			},
			// 搜索
			searchName()
			{
				searchUserPage(
				{
					page:1,
					pageSize:10,
					name:this.user,
				})
				.then((response)=>
				{
					if(response.data.data.records.length==0)
					{
						this.open();
					}
					else
					{
						this.form=response.data.data.records;
					}
				})
			},
			// 重置
			reset()
			{
				this.user='';
				this.resetList();
			},
			// 没有数据
			open() 
			{
				this.$alert('请查看是否输入正确', '没有找到相关数据', 
				{
					confirmButtonText: '确定',
				});
			},
			del(item)
			{
				this.$confirm('是否删除数据?', '删除数据',
				{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
				})
				.then(() => 
				{
					deleteUser({data:item})
					.then((response)=>
					{
						this.$message.success('删除成功')
						this.resetList()
					})
				})
				.catch(() => {
					this.$message.info('已取消删除')
					return false;
				})	
			},
			// 重新刷新数据
			resetList()
			{
				this.page=1;
				this.pageSize=10;
				this.getUser()
			},
			// 新增
			add()
			{
				this.id=''
				this.saveForm={};
				this.value=false;
				this.isedit=false;
			},
			// 编辑
			edit(item)
			{
				this.id=item.id
				this.saveForm=item;
				this.value=false;
				this.isedit=true;
			},
			// 保存
			save()
			{
				if(this.saveForm.password.length<6)
				{
					this.$message.error('密码位数应大于六位，请重新输入。')
					return false;
				}
				if(this.saveForm.password!=this.saveForm.passwordAgain)
				{
					this.$message.error('确认密码失败，请重新确认密码')
					return false;
				}
				chackName({name:this.saveForm.name,id:this.saveForm.id})
				.then((response)=>
				{
					if(response.data.data.isSuccess==false)
					{
						this.$message.error('该用户名存在，请重新添加')
						return false;
					}
					else
					{
						if(this.id=='')
						{
							editUser({name:this.saveForm.name,password:this.saveForm.password})
							.then((response)=>
							{
								this.$message.success('添加成功')
								this.value=true;
								this.resetList()
							})
						}
						else
						{
							editUser({name:this.saveForm.name,password:this.saveForm.password,id:this.id})
							.then((response)=>
							{
								this.$message.success('编辑成功')
								this.value=true;
								this.resetList()
							})
						}
					}
				})
			},
			// 取消
			cancel()
			{
				this.saveForm={};
				this.value=true;
				this.resetList()
			}
		}
	}
</script>

<style scoped>
	@import '../assets/table.css';
	.crumbs{
		width: 100%;
		padding: 10px 0px 10px;
	}
	.selectbox{
		 margin-top: 10px;
		 margin-bottom: 20px;
	}
	.title{
		line-height: 30px;
	}
	.select{
		width: 100%;
		height: 30px;
	}
	.formbox{
		background-color: #F2F2F2;
		padding-left: 10px;
		margin-top: 10px;
	}
	.tablebox{
		width: 98%;
		background-color: #E4E4E4;
	}
	.table-trtitle{
		height: 50px;
		background-color: white;
		margin-top: 10px;
	}
	#add{
		margin-left: 3%;
		padding-top: 10px;
	}
	.add-title{
		text-align: left;
		margin-top: 20px;
		margin-bottom: 20px;
		font-weight: bold;
		color: black;
	}
	.head{
		color: #409eff;
		cursor: pointer;
	}
	.total{
		text-align: left;
		margin-top: 10px;
		font-size: 14px;
	}
</style>